const POST_PREVIEW_MAX_CHARACTERS = 280;
const POST_PREVIEW_MAX_LINES = 5;
const IDENTITY_TOKEN_PATTERN =
  /(https?:\/\/[^\s<*]+|www\.[^\s<*]+|@[a-zA-Z0-9_.]+|#[\p{L}\p{N}_]+)/giu;
const TOKEN_START = '\uE000';
const TOKEN_END = '\uE001';

/**
 * The API stores plain text, but pasted and AI-generated posts can contain
 * Markdown decoration. Plain-text renderers cannot interpret that markup, so
 * remove only common presentation tokens while preserving the actual copy.
 */
export function normalizePlainPostText(text: string): string {
  const tokens: string[] = [];
  const protectedText = text.replace(IDENTITY_TOKEN_PATTERN, token => {
    const index = tokens.push(token) - 1;
    return `${TOKEN_START}${index}${TOKEN_END}`;
  });

  return protectedText
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .filter(line => !/^\s*(?:-{3,}|_{3,}|\*{3,})\s*$/.test(line))
    .map(line => line.replace(/^\s{0,3}#{1,6}\s+/, ''))
    .join('\n')
    .replace(/\*\*\*([^*\n]+)\*\*\*/g, '$1')
    .replace(/\*\*([^*\n]+)\*\*/g, '$1')
    .replace(/___([^_\n]+)___/g, '$1')
    .replace(/__([^_\n]+)__/g, '$1')
    .replace(/\*{2,3}/g, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
    .replace(
      new RegExp(`${TOKEN_START}(\\d+)${TOKEN_END}`, 'g'),
      (_, index: string) => tokens[Number(index)] ?? '',
    );
}

export function shouldCollapsePostText(text: string): boolean {
  const normalized = normalizePlainPostText(text);
  const visibleLines = normalized
    .split('\n')
    .filter(line => line.trim().length > 0).length;

  return (
    normalized.length > POST_PREVIEW_MAX_CHARACTERS ||
    visibleLines > POST_PREVIEW_MAX_LINES
  );
}
